import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import NavigationButtons from './NavigationButtons';
import { useFetchTAndCPdf } from 'Features/ContractRelease/Services/release.service';
import styles from './pre-ex6.module.css';
import useGrouping from 'Common/Utils/Hooks/useGrouping';

const ViewTAndC = ({ row, handleActive }) => {
	const [pdf, setPdf] = useState(null);
	const { qualificationYear: year, type } = row;
	const grouping = useGrouping();
	document.title = `Contract Management - ${row.title} (${row.markingTeamCode})`;

	const { isLoading, isSuccess } = useFetchTAndCPdf(year, grouping, type, setPdf);

	return (
		<>
			<Card className={styles.view_pdf_root} variant="outlined">
				<CardHeader
					title={
						<Typography noWrap component="h2">
							{row.title}
						</Typography>
					} 
					subheader={
						<Typography noWrap component="h2">
							({row.markingTeamCode})
						</Typography>						
					} 
					action={<NavigationButtons row={row} action={handleActive} />} >
				</CardHeader>
				<CardMedia className={styles.media} title="Terms and Conditions">
					{isLoading ? (
						<LinearProgress color="secondary" />
					) : !isSuccess ? (
						<div>Unable to Retrieve PDF</div>
					) : (
						<object width="100%" height="370" type="application/pdf" data={`data:application/pdf;base64,${pdf}`}>
							This is supposed to be a PDF
						</object>
					)}
				</CardMedia>
				<CardActions></CardActions>
			</Card>
		</>
	);
};

ViewTAndC.propTypes = {
	row: PropTypes.array.isRequired,
	handleErrors: PropTypes.func.isRequired
};

export default ViewTAndC;
